<!-- 没有图，显示骨架 -->
<div *ngIf="!thumbDone() && !hdDone()" class="skeleton-loading" [class.hide-when-alone]="defaultShowBlock"></div>
<!-- 清晰图 -->
<img
  loading="lazy"
  draggable="false"
  *ngIf="hdSrc() as hurl"
  [src]="hurl"
  (error)="hdError.set(true)"
  (load)="hdDone.set(true)"
  [attr.alt]="alt || null"
  [style.z-index]="hdDone() ? 1 : 0"
/>
<!-- 模糊图 -->
<img
  draggable="false"
  *ngIf="thumbSrc() as turl"
  [src]="turl"
  (error)="thumbError.set(true)"
  (load)="thumbDone.set(true)"
  [attr.alt]="alt || null"
  [style.display]="hdDone() ? 'none' : 'block'"
/>
